import { ConfirmationAddressInterfaceState, initialConfirmationAddressState } from '../state/confirmation-address.state';
import { ConfirmationAddressActions, EConfirmationAddressActions } from '../actions/confirmation-address.actions';

export function confirmationAddressReducer(state: ConfirmationAddressInterfaceState = initialConfirmationAddressState, action: ConfirmationAddressActions): ConfirmationAddressInterfaceState {
  switch (action.type) {
    case EConfirmationAddressActions.VisibilityConfirmationAddress: {
      return { ...state, visibility: action.payload };
    }

    default:
      return state;
  }
};
